import React from 'react';
import NFTModal from './NFTModal';
import { earlyPackImage } from '../assets';

const EARLYPACK_MARKETPLACES = [
  {
    name: "SentX",
    url: "https://sentx.io/nft-marketplace/early-pack",
    priceKey: "sentx",
    displayNameKey: "sentxMarket"
  },
  {
    name: "Kabila",
    url: "https://market.kabila.app/collections/3934915/items",
    priceKey: "kabila",
    displayNameKey: "kabilaMarket"
  }
];

const EarlyPackModal = ({ isOpen, onClose }) => (
  <NFTModal
    isOpen={isOpen}
    onClose={onClose}
    collectionKey="earlyPack"
    image={earlyPackImage}
    titleKey="modals.earlyPackTitle"
    descKey="modals.earlyPackDesc"
    benefitsKey="modals.earlyPackBenefits"
    benefitsDescKey="modals.earlyPackBenefitsDesc"
    benefitsIcon="🎁"
    marketplaces={EARLYPACK_MARKETPLACES}
  />
);

export default EarlyPackModal;
